// extracted by mini-css-extract-plugin
export var closeButton = "referralModal-module--closeButton--597dc";
export var container = "referralModal-module--container--40569";
export var text = "referralModal-module--text--6f3c0";
export var title = "referralModal-module--title--410d5";